import {Column, Entity, PrimaryColumn} from "typeorm";

@Entity()
export class PasswordResetTokens {

	@PrimaryColumn()
  user_email!: string

  @Column()
  token!: string

  @Column('datetime')
  expires!: Date;

}